import { render, staticRenderFns } from "./OrderTabPatientInfo.vue?vue&type=template&id=21e1f4ef&"
import script from "./OrderTabPatientInfo.vue?vue&type=script&lang=js&"
export * from "./OrderTabPatientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports